import { InsightTable } from './InsightTable';
import { useProfileQueryContext } from '../../../contexts/demographicInsights';
import { useTranslation } from '../../../hooks';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';

export const LocalesTable = () => {
  const { t } = useTranslation();
  const { hasLocales } = useLocaleSettingsContext();
  const { locales } = useProfileQueryContext();
  const title = t('insights.locales');

  const isLocaleTableVisible = hasLocales && !!locales?.length;

  return (
    <InsightTable
      title={title}
      values={locales ?? []}
      hasChart
      showDivider
      isEnabled={isLocaleTableVisible}
    />
  );
};
